export const ActionTypes = {
    SET_TODO_ITEMS: 'SET_TODO_ITEMS',
    SET_OTHER_ITEMS: 'SET_OTHER_ITEMS',
    SET_COMPLIANCE_ITEMS: 'SET_COMPLIANCE_ITEMS',
    SET_PENDING_SWAPS: 'SET_PENDING_SWAPS',
    SET_PAST_TRANSPLANTS: 'SET_PAST_TRANSPLANTS',
    SET_LOOKUP_DATA: 'SET_LOOKUP_DATA',
    SET_PENDING_SWAPS_DONOR: 'SET_PENDING_SWAPS_DONOR',
    SET_CHAIN_END_DECLINE_RATIO: 'SET_CHAIN_END_DECLINE_RATIO'
}
